import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux'
import grey from '@material-ui/core/colors/grey';

import Profile from './Profile'
import Harvest from './Harvest'
import Water from './Water'
import Calender from './Calender'
import GreenhouseEnvironment from './GreenhouseEnvironment'
import Weather from './Weather'

const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              backgroundColor: grey[200],
              paddingTop: 4,
              paddingBottom: 4,
            },
      paper: {
              marginLeft: 10,
              display: 'flex',
              overflow: 'auto',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: '400',
            },
});

const DigitalFarm = () => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
        return (
           <Container maxWidth="lg" className={classes.container}>
           <h1>Digital Farm</h1>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <Paper className={fixedHeightPaper}>
                      <Profile />
                      </Paper>
                    </Grid>
                    <Grid item xs={8}>
                      <Paper className={fixedHeightPaper}>
                      <Harvest />
                      </Paper>
                    </Grid>
                    <Grid item xs={12}>
                      <Paper className={fixedHeightPaper}>
                      <Calender />
                      </Paper>
                    </Grid> 
                    <Grid item xs={4}>
                      <Paper className={fixedHeightPaper}>
                      <Water />
                      </Paper>
                    </Grid> 
                    <Grid item xs={4}>
                      <Paper className={fixedHeightPaper}>
                      <Weather />
                      </Paper>
                    </Grid> 
                    <Grid item xs={12}>
                      <Paper className={fixedHeightPaper}>
                      <GreenhouseEnvironment />
                      </Paper>
                    </Grid> 
                  </Grid>
           </Container>
        )
  }

export default DigitalFarm